import api from "./api";

/**
 * These are only valid on the server.
 */
const env = process?.env ?? {};

function toBool(str: string | undefined, def: boolean = false): boolean {
  return typeof str === "string" && "TtYy1".includes(str.trim().slice(0, 1));
}

export const paServerDomain = env.PA_DOMAIN;

// only used for Strapi page builds
export const paServerStrapiUrl = env.PA_STRAPI_URL;
export const paServerStrapiAuth = env.PA_STRAPI_AUTH;
export const paServerStrapiPreview = toBool(env.PA_STRAPI_PREVIEW, false);
export const paServerStrapiBuild = toBool(env.PA_BUILD_STRAPI, true);

// only used for Inventory page builds
export const paServerPreloginApi =
  env.PA_LISTING_API ?? `https://prelogin.${paServerDomain}`;
export const paServerInventoryBuild = toBool(env.PA_BUILD_LISTINGS, true);

export const paServerRunBuggyId = env.PA_RUNBUGGY_ID;
export const paServerRunBuggyUrl = env.PA_RUNBUGGY_URL;

export const paServerAlgoliaAppId = env.PA_ALGOLIA_APPID;
export const paServerAlgoliaKey = env.PA_ALGOLIA_API_KEY;

// Server-side secret token for API authentication
export const paServerSecretToken = env.SECRET_TOKEN ?? "privateauto";

export const serverApi = () => api(paServerPreloginApi);
